function setIsOpenAndSetExpanded(isOpen, setIsOpen, expanded, toggleDrawer) {
  if (!isOpen) {
    setIsOpen();
  }

  toggleDrawer();
}

export default setIsOpenAndSetExpanded;
